<div class="cadastro-advogado-container">
  <div class="header">
    <h1>Cadastro de Advogados</h1>
    <button class="btn btn-primary" (click)="openModal(formModal, true)">Novo Advogado</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroCognome">Sobrenome:</label>
          <input 
            type="text" 
            id="filtroCognome" 
            class="form-control" 
            [(ngModel)]="filtroCognome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por sobrenome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroLingua">Língua:</label>
          <select 
            id="filtroLingua" 
            class="form-control" 
            [(ngModel)]="filtroLingua"
            (change)="aplicarFiltros()">
            <option value="">Todas</option>
            <option value="linguE_PORTOGHESE">Português</option>
            <option value="linguE_SPAGNOLO">Espanhol</option>
            <option value="linguE_INGLESE">Inglês</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroCassazionista">Cassazionista:</label>
          <select 
            id="filtroCassazionista" 
            class="form-control" 
            [(ngModel)]="filtroCassazionista"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-end">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Cognome</th>
          <th>Nome</th>
          <th>Telefono</th>
          <th>E-mail</th>
          <th>PEC</th>
          <th>CF</th>
          <th>P.IVA</th>
          <th>Lingue</th>
          <th>Cassazionista</th>
          <th>Data Cadastro</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let advogado of advogadosFiltrados">
          <td>{{ advogado.cognome }}</td>
          <td>{{ advogado.nome }}</td>
          <td>{{ advogado.telefono }}</td>
          <td>{{ advogado.email }}</td>
          <td>{{ advogado.pec }}</td>
          <td>{{ advogado.cf }}</td>
          <td>{{ advogado.piva }}</td>
          <td>
            <span *ngIf="advogado.linguE_PORTOGHESE" class="badge bg-primary me-1">Portoghese</span>
            <span *ngIf="advogado.linguE_SPAGNOLO" class="badge bg-success me-1">Spagnolo</span>
            <span *ngIf="advogado.linguE_INGLESE" class="badge bg-info">Inglês</span>
          </td>
          <td>
            <span class="badge" [ngClass]="advogado.cassazionista ? 'bg-success' : 'bg-warning'">
              {{ advogado.cassazionista ? 'Sì' : 'No' }}
            </span>
          </td>
          <td>{{ advogado.datA_CADASTRO | date:'dd/MM/yyyy' }}</td>
          <td>
            <button class="btn btn-sm btn-warning me-2" (click)="editarAdvogado(advogado); openModal(formModal)">
              <i class="fa fa-edit"></i> Editar
            </button>
            <!--<button class="btn btn-sm btn-danger" (click)="excluirAdvogado(advogado.id)">
              <i class="fa fa-trash"></i> Excluir
            </button>-->
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
      <h4 class="modal-title">{{ advogadoSelecionado ? 'Editar Advogado' : 'Novo Advogado' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="cognome">Cognome:</label>
              <input 
                type="text" 
                id="cognome" 
                formControlName="cognome" 
                class="form-control"
                placeholder="Digite o sobrenome">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="nome">Nome:</label>
              <input 
                type="text" 
                id="nome" 
                formControlName="nome" 
                class="form-control"
                placeholder="Digite o nome">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="telefono">Telefono:</label>
              <input 
                type="text" 
                id="telefono" 
                formControlName="telefono" 
                class="form-control"
                placeholder="+39 XXX XXX XXXX"
                [textMask]="{mask: telefoneMask}">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">E-mail:</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control"
                placeholder="seu@email.com">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="pec">PEC:</label>
              <input 
                type="email" 
                id="pec" 
                formControlName="pec" 
                class="form-control"
                placeholder="seu@pec.it">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cf">CF:</label>
              <input 
                type="text" 
                id="cf" 
                formControlName="cf" 
                class="form-control"
                placeholder="XXXXXX00X00X000X"
                >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="piva">P.IVA:</label>
              <input 
                type="text" 
                id="piva" 
                formControlName="piva" 
                class="form-control"
                placeholder="00000000000"
                [textMask]="{mask: pivaMask}">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="indirizzo">Indirizzo studio:</label>
          <textarea 
            id="indirizzo" 
            formControlName="indirizzo" 
            class="form-control"
            placeholder="Digite o endereço do escritório"
            rows="3"></textarea>
        </div>

        <div class="form-group checkbox-group">
          <label class="mb-2">LINGUE STRANIERE:</label>
          <div class="row">
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="linguaPortoghese" formControlName="linguaPortoghese" class="form-check-input">
                <label for="linguaPortoghese" class="form-check-label">Portoghese</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="linguaSpagnolo" formControlName="linguaSpagnolo" class="form-check-input">
                <label for="linguaSpagnolo" class="form-check-label">Spagnolo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="linguaInglese" formControlName="linguaInglese" class="form-check-input">
                <label for="linguaInglese" class="form-check-label">Inglese</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group checkbox-group mt-4">
          <label class="mb-2">Cassazionista:</label>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check">
                <input type="radio" id="cassazionistaSim" formControlName="cassazionista" [value]="true" class="form-check-input">
                <label for="cassazionistaSim" class="form-check-label">Sì</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check">
                <input type="radio" id="cassazionistaNo" formControlName="cassazionista" [value]="false" class="form-check-input">
                <label for="cassazionistaNo" class="form-check-label">No</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!cadastroForm.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 